import { render, staticRenderFns } from "./TabletServiceForm.vue?vue&type=template&id=32db6b80&"
import script from "./TabletServiceForm.vue?vue&type=script&lang=js&"
export * from "./TabletServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports